<template>
    <div>
        <div class="box is-light wdt mb-4 has-text-centered" style="width: 600px; max-width: 100%; margin: auto;">
            <div class="has-text-grey is-size-7 has-text-left is-uppercase">
                #{{ cancellationKey }}
            </div>

            <div class="is-size-5 mt-2 mb-4 has-text-centered">
                <div class="has-text-grey" v-if="recordLocator">
                    Trip Record Locator:
                    <div class="has-text-centered has-text-weight-semibold">
                        {{ recordLocator }}
                    </div>
                </div>

                <div v-if="!hasStageComplete" class="has-text-weight-semibold mt-2 has-text-grey-dark mb-4">
                    Cancellation Failed
                </div>

                <div v-else-if="hasStageComplete && cancellationComplete == false" class="my-5 is-size-6 is-default">
                    We were able to cancel part of your trip, but ran into some issues.
                </div>

                <div v-else-if="cancellationComplete" class="is-size-4 mt-2 mb-4 has-text-centered">
                    Your Cancellation was Successful
                </div>

                <b-message type="is-warning" class="has-text-left" v-if="additionalNotes">
                    <ul>
                        <li v-if="sentToTicketCancelQueue">Request for flight credit has been submitted.</li>
                    </ul>
                </b-message>

                <div v-if="hasStageComplete">
                    <CancellationStageStatus v-for="stage in cancelStages" :key="stage.slug" :stage="stage"
                        :hasNonRefundableHotel="hasNonRefundableHotel"
                        :sentToTicketCancelQueue="sentToTicketCancelQueue" />
                </div>


                <div v-if="cancellationComplete == false || !response.success"
                    class="notification has-text-centered  is-light is-danger is-size-6">
                    We encountered an error during the cancellation process. Please try to submit your
                    cancellation again for the failed segment(s) or contact us using
                    one of the methods below to complete your cancellation.
                </div>

            </div>

            <p class="mb-2">
                Email Gant's Online Team:
                <a href="mailto:clientservices@ganttravel.com">
                    clientservices@ganttravel.com
                </a>
            </p>
            <p class="mb-2">
                Contact Gant Travel directly for agent assistance at 877-924-0303
            </p>

        </div>
    </div>
</template>

<script>
//import TripCard from "@/components/Trip/TripCard";
import CancellationStageStatus from "@/components/Trip/Cancellation/CancellationStageStatus";
import router from "@/router";
export default {
    name: "CancellationConfirmation",
    components: { CancellationStageStatus },
    props: {
        response: {
            required: true,
            type: Object,
        }
    },
    data: function () {
        return {};
    },
    computed: {
        recordLocator() {
            return this.response.meta?.recordLocator;
        },
        cancellationKey() {
            return this.response.meta?.cancellationKey;
        },
        cancelStages() {
            return this.response.data;
        },
        hasNonRefundableHotel() {
            return this.response.meta?.hasNonRefundableHotel;

        },
        sentToTicketCancelQueue() {
            return this.response.meta?.sentToTicketCancelQueue;
        },
        additionalNotes() {
            // Put other notes here if needed
            if (this.sentToTicketCancelQueue) {
                return true;
            }
            return false;
        },
        //Check each air/car/hotel booking stage; true if at least one is complete
        hasStageComplete() {
            let hasStageComplete = false;
            let stages = this.cancelStages;
            if (stages) {
                stages.forEach((stage) => {
                    if (stage.isComplete) {
                        hasStageComplete = true;
                    }
                });
            }

            return hasStageComplete;
        },
        //Check each air/car/hotel booking stage; true if at least one is not complete
        cancellationComplete() {
            let complete = true;
            let stages = this.cancelStages;
            if (stages) {
                stages.forEach((stage) => {
                    if (!stage.isComplete) {
                        complete = false;
                    }
                });
            }

            return complete;
        }
    },

};
</script>

<style>
.message-body li {
    padding: 0 0 0.5rem 0;
}
</style>